import { memo } from 'react';
import { Col, Row, Table } from 'reactstrap';

import { formatDateDifference } from '../../../helpers/date';

import styles from './Livestock.module.scss';

import default_animal from '../../../assets/images/default-animal.jpg';

function Livestock(props) {
  const animalId = props.animal.at(0);
  const animal = props.animals.find(a => a.id === animalId);

  return (
    <div className={styles['animal-box']}>
      <Row>
        <Col sm="12" md="12" lg="3">
          <img
            className={styles['animal-profile-pic']}
            src={animal?.photo || default_animal}
            alt="Animal picture"
            width="150"
          />
        </Col>
        <Col sm="12" md="12" lg="9">
          <Table responsive className="no-border">
            <tbody>
              <tr>
                <td>Official Tag ID</td>
                <td>
                  <span className="text-mute">{animal.eartag_official_id}</span>
                </td>
              </tr>
              <tr>
                <td>Tag ID</td>
                <td>
                  <span className="text-mute">{animal.id}</span>
                </td>
              </tr>
              <tr>
                <td>Management Tag ID</td>
                <td>
                  <span className="text-mute">{animal.eartag_official_id}</span>
                </td>
              </tr>
              <tr>
                <td>Livestock ID</td>
                <td>
                  <span className="text-mute">{animal.id}</span>
                </td>
              </tr>
              <tr>
                <td>Age</td>
                <td>
                  <span className="text-mute">{formatDateDifference(animal.age)}</span>
                </td>
              </tr>
              <tr>
                <td>Breed</td>
                <td>
                  <span className="text-mute">{animal.breed?.display_name}</span>
                </td>
              </tr>
              <tr>
                <td>Sex</td>
                <td>
                  <span className="text-mute capitalize">{animal?.sex}</span>
                </td>
              </tr>
              <tr>
                <td>Description</td>
                <td>
                  <span className="text-mute">{animal?.description}</span>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
}

export default memo(Livestock);
